import { PaletteMode, PaletteOptions, ThemeOptions } from '@mui/material'
import { ICustomTheme } from '../../interfaces/theme'
import {
  YaloDarkPalette,
  YaloLightPalette,
  YaloThemeOptions
} from './themeBase'

export const combinePalettes = (
  YaloPalette: PaletteOptions = {},
  customPalette: PaletteOptions = {}
): PaletteOptions => ({
  ...YaloPalette,
  ...customPalette
})

export const getTheme = (
  mode: PaletteMode,
  theme: ICustomTheme
): ThemeOptions => {
  const {
    palette: { light = null, dark = null, ...customPaletteOptions } = {},
    ...customThemeOptions
  } = theme || {}

  const combinedPalette =
    mode === 'light'
      ? combinePalettes(YaloLightPalette, light || customPaletteOptions)
      : combinePalettes(YaloDarkPalette, dark || customPaletteOptions)

  return {
    palette: {
      mode,
      ...combinedPalette
    },
    ...YaloThemeOptions,
    ...customThemeOptions
  }
}
